<div
  #segmentEl
  class="discount-segment"
  [ngStyle]="{ 'margin-left.px': segmentMarginLeft }"
>
  <ng-container *ngFor="let nivel of Niveles; let last = last">
    <div
      class="discount-segment-btn"
      [class.has-checkmark]="nivel.Cumple"
      [class.is-last]="false"
      [attr.data-nivel]="nivel.Nivel"
    >
      <div class="level-container">
        <ion-avatar
          class="circle-main"
          [ngStyle]="{
            'background-color':
              nivel.Nivel === level || nivel.Cumple
                ? 'var(--ion-color-getm-neutral-white)'
                : 'var(--ion-color-getm-primary-hover)'
          }"
        >
          <ion-text
            [color]="
              nivel.Nivel === level || nivel.Cumple
                ? 'getm-primary-selected'
                : 'getm-neutral-white'
            "
            class="text-percent"
            [ngStyle]="{ 'font-size': nivel.Descuento === 1 ? '13px' : '16px' }"
          >
            {{ nivel.Descuento | percent : '1.0-2' }}
          </ion-text>
        </ion-avatar>

        <ion-badge
          *ngIf="nivel.Cumple"
          color="getm-success-default"
          class="circle-badge"
        >
          <ion-icon name="checkmark-sharp"></ion-icon>
        </ion-badge>

        <ion-text color="getm-information-light" class="text-range">
          {{ nivel.Minimo }} {{ 'Labels.a' | translate }} {{ nivel.Maximo }}
        </ion-text>
      </div>
    </div>
  </ng-container>
</div>
